export default "__VITE_ASSET__cGkkRLSk__"